import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  private data: any = {};
  keysShared = [
    'topic',
    'ndid-response',
    'ndid-req-response',
    'ndid-requested',
    'application_id',
    'redirect_url',
    'parent_txn_id',
    'pre_id_card_number',
    'force_completion',
    'error-response',
    'client-error',
    'retry_get_product',
    'loan_type'
  ];
  localStorageKey = [
    'is_resume',
    'selected-thaid',
    'ndid-requested',
    // 'deviceCheckCompleted' not clearing this key as it is used in device preparation flow
  ];

  setData(key: string, value: any): void {
    this.data[key] = value;
  }

  getData(key: string): any {
    return this.data[key];
  }

  clearData(key: string): void {
    delete this.data[key];
  }

  clearAllData(): void {
    for (const key of this.keysShared) {
      delete this.data[key];
    }
  }

  clearLocalStorage(): void {
    for (const key of this.localStorageKey) {
      localStorage.removeItem(key);
    }
  }

  async clearAppData(): Promise<void> {
    const authSession = localStorage.getItem('auth_session');

    // Memory
    this.clearAllData();

    // Storage
    localStorage.clear();
    sessionStorage.clear();

    // Cache
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map(key => caches.delete(key)));
    }

    // IndexedDB
    if ('indexedDB' in window && indexedDB.databases) {
      const databases = await indexedDB.databases();

      await Promise.all(
        databases
          .filter(db => db.name)
          .map(
            db =>
              new Promise<void>((resolve, reject) => {
                const request = indexedDB.deleteDatabase(db.name!);

                request.onsuccess = () => resolve();
                request.onerror = () => reject(request.error);
                request.onblocked = () => resolve();
              })
          )
      );
    }

    // Service Worker
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(r => r.unregister()));
    }

    // Restore auth session
    if (authSession) {
      localStorage.setItem('auth_session', authSession);
    }
  }
}
